import { graphql } from '@api/generated';

export const getContactCenterTenants = graphql(`
  query getContactCenterTenants {
    contactCenterTenants {
      id
      name
      isCommHubTextingEnabled
      isNextGenJobBookingEnabled
      isGranularPermissionsEnabled
    }
  }
`);
